// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IJ-z","twoColumnImage":"JJ-z"};